<template>
  <v-container fluid class="ma-0 pa-0">
    <v-row class="ma-0 pa-0">
      <v-col cols="12">
        <v-card class="elevation-2">
          <v-card-title>
            Confronto Multi-Anno
            <v-spacer />
            <v-select v-model="anniSelezionati" :items="anniDisponibili" label="Seleziona anni" multiple chips dense
              style="max-width: 300px;" @change="aggiornaConfrontoMultiAnno" />
          </v-card-title>
          <v-card-text>
            <line-chart :data="graficoMultiAnno" :options="opzioniLinea" :key="keyMulti" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="ma-0 pa-0 mt-3">
      <v-col cols="12" md="6">
        <v-card class="elevation-2">
          <v-card-title> Variazione % Anno su Anno
            <v-chip small class="ml-2" :color="modalita === 'importi' ? 'success' : 'primary'">
              {{ modalita === 'importi' ? 'Importi' : 'Ore' }}
            </v-chip>
          </v-card-title>
          <v-card-text>
            <bar-chart :data="graficoYoY" :options="opzioniBarre" :key="keyYoY" />
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card class="elevation-2">
          <v-card-title>Analisi Trimestrale
            <v-chip small class="ml-2" :color="modalita === 'importi' ? 'success' : 'primary'">
              {{ modalita === 'importi' ? 'Importi' : 'Ore' }}
            </v-chip>
          </v-card-title>
          <v-card-text>
            <bar-chart :data="graficoTrimestri" :options="opzioniBarre" :key="keyTrim" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="ma-0 pa-0 mt-3">
      <v-col cols="12">
        <v-card class="elevation-2">
          <v-card-title>Dettaglio Trimestrale</v-card-title>
          <v-card-text>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th rowspan="2">Trimestre</th>
                    <th colspan="3" class="text-center">Importi (€)</th>
                    <th colspan="3" class="text-center">Ore</th>
                  </tr>
                  <tr>
                    <th class="text-right">{{ filtri.anno }}</th>
                    <th class="text-right">{{ filtri.anno - 1 }}</th>
                    <th class="text-right">Var %</th>
                    <th class="text-right">{{ filtri.anno }}</th>
                    <th class="text-right">{{ filtri.anno - 1 }}</th>
                    <th class="text-right">Var %</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(trim, i) in datiTrimestri" :key="i">
                    <td class="font-weight-bold">{{ trim.nome }}</td>
                    <td class="text-right">{{ formattaImporto(trim.correnteImporti) }}</td>
                    <td class="text-right">{{ formattaImporto(trim.precedenteImporti) }}</td>
                    <td class="text-right" :class="trim.variazioneImporti >= 0 ? 'success--text' : 'error--text'">
                      <v-icon small :color="trim.variazioneImporti >= 0 ? 'success' : 'error'">
                        {{ trim.variazioneImporti >= 0 ? 'trending_up' : 'trending_down' }}
                      </v-icon>
                      {{ Math.abs(trim.variazioneImporti).toFixed(1) }}%
                    </td>
                    <td class="text-right">{{ trim.correnteOre.toFixed(0) }} h</td>
                    <td class="text-right">{{ trim.precedenteOre.toFixed(0) }} h</td>
                    <td class="text-right" :class="trim.variazioneOre >= 0 ? 'success--text' : 'error--text'">
                      <v-icon small :color="trim.variazioneOre >= 0 ? 'success' : 'error'">
                        {{ trim.variazioneOre >= 0 ? 'trending_up' : 'trending_down' }}
                      </v-icon>
                      {{ Math.abs(trim.variazioneOre).toFixed(1) }}%
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { get_confronto_multi_anno_ore, get_variazione_yoy_ore, get_analisi_trimestri_ore } from "@/api/api.clienti.js";
import LineChart from "@/components/chart/LineChart.js";
import BarChart from "@/components/chart/BarChart.js";
import mixinCharts from "@/components/chart/mixinCharts.js";

export default {
  name: "TabConfrontiOre",

  components: {
    LineChart,
    BarChart
  },

  mixins: [mixinCharts],

  props: {
    filtri: { type: Object, default: () => ({}) },
    modalita: { type: String, default: 'importi' },
    aggiornaDati: { type: Number, default: 0 }
  },

  data: () => ({
    anniSelezionati: [],
    anniDisponibili: [],

    graficoMultiAnno: {},
    graficoYoY: {},
    graficoTrimestri: {},

    opzioniLinea: {},
    opzioniBarre: {},

    keyMulti: 0,
    keyYoY: 0,
    keyTrim: 0,

    datiTrimestri: []
  }),

  methods: {
    inizializzaAnni() {
      const annoCorrente = new Date().getFullYear();
      this.anniDisponibili = [];

      for (let i = 0; i < 6; i++) {
        this.anniDisponibili.push(annoCorrente - i);
      }

      this.anniSelezionati = [this.filtri.anno, this.filtri.anno - 1];
    },

    async aggiornaConfrontoMultiAnno() {
      if (this.anniSelezionati.length === 0) return;

      try {
        let res = await get_confronto_multi_anno_ore({
          anni: this.anniSelezionati,
          soloDaFatturare: this.filtri.soloDaFatturare
        });

        const mesi = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
        const colori = ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF'];

        const datasets = res.data.map((annoData, i) => {
          const dati = this.modalita === 'importi'
            ? annoData.datiMensiliImporti
            : annoData.datiMensiliOre;

          return {
            label: annoData.anno.toString(),
            data: dati,
            fill: false,
            borderColor: colori[i % colori.length],
            backgroundColor: colori[i % colori.length],
            borderWidth: 2,
            tension: 0.4,
            pointRadius: 4,
            pointHoverRadius: 6
          };
        });

        this.graficoMultiAnno = {
          labels: mesi,
          datasets: datasets
        };

        this.keyMulti++;

      } catch (error) {
        console.error("Errore caricamento confronto multi-anno:", error);
      }
    },

    async caricaDatiYoY() {
      try {
        let res = await get_variazione_yoy_ore(this.filtri);

        const etichette = res.data.map(d => `${d.annoCorrente} vs ${d.annoPrecedente}`);
        const variazioni = this.modalita === 'importi'
          ? res.data.map(d => d.variazionePercentualeImporti)
          : res.data.map(d => d.variazionePercentualeOre);

        const colori = variazioni.map(v =>
          v >= 0 ? 'rgba(76, 175, 80, 0.7)' : 'rgba(244, 67, 54, 0.7)'
        );

        this.graficoYoY = {
          labels: etichette,
          datasets: [{
            label: 'Variazione %',
            data: variazioni,
            backgroundColor: colori,
            borderWidth: 0
          }]
        };

        this.keyYoY++;

      } catch (error) {
        console.error("Errore caricamento YoY:", error);
      }
    },

    async caricaDatiTrimestri() {
      try {
        let res = await get_analisi_trimestri_ore(this.filtri);

        this.datiTrimestri = res.data;

        const etichette = res.data.map(t => t.nome);
        const valoriCorrente = this.modalita === 'importi'
          ? res.data.map(t => t.correnteImporti)
          : res.data.map(t => t.correnteOre);
        const valoriPrecedente = this.modalita === 'importi'
          ? res.data.map(t => t.precedenteImporti)
          : res.data.map(t => t.precedenteOre);

        this.graficoTrimestri = {
          labels: etichette,
          datasets: [
            {
              label: this.filtri.anno.toString(),
              data: valoriCorrente,
              backgroundColor: 'rgba(33, 150, 243, 0.7)',
              borderColor: 'rgba(33, 150, 243, 1)',
              borderWidth: 2
            },
            {
              label: (this.filtri.anno - 1).toString(),
              data: valoriPrecedente,
              backgroundColor: 'rgba(255, 152, 0, 0.7)',
              borderColor: 'rgba(255, 152, 0, 1)',
              borderWidth: 2
            }
          ]
        };

        this.keyTrim++;

      } catch (error) {
        console.error("Errore caricamento trimestri:", error);
      }
    },

    formattaImporto(valore) {
      return '€ ' + this.$functions.numberWithCommas(valore.toFixed(2));
    },

    caricaTuttiDati() {
      this.aggiornaConfrontoMultiAnno();
      this.caricaDatiYoY();
      this.caricaDatiTrimestri();
    }
  },

  mounted() {
    this.opzioniLinea = this.getOptionsMixedChart();
    this.opzioniBarre = this.getOptionsMixedChart();
    this.inizializzaAnni();
    this.caricaTuttiDati();
  },

  watch: {
    aggiornaDati() {
      this.graficoMultiAnno = {};
      this.graficoYoY = {};
      this.graficoTrimestri = {};
      this.opzioniLinea = {};
      this.opzioniBarre = {};
      this.opzioniLinea = this.getOptionsMixedChart();
      this.opzioniBarre = this.getOptionsMixedChart();
      this.inizializzaAnni();
      this.caricaTuttiDati();
    },

    modalita() {
      this.aggiornaConfrontoMultiAnno();
      this.caricaDatiYoY();
      this.caricaDatiTrimestri();
    }
  }
}
</script>